import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';

Swiper.use([Pagination]);

export default class MobileSlider {
    constructor(swiperContainerSelector, swiperSlidesContainerSelector) {
        this.swiperContainer = swiperContainerSelector;
        this.swiperSlidesContainer = swiperSlidesContainerSelector;
        this.initListeners();
    }

    initListeners() {
        window.addEventListener('resize', () => {
            if (window.innerWidth <= 715) {
                this.initSwiper();
            } else {
                this.disableSwiper();
            }
        }, {passive: true});

        document.addEventListener('DOMContentLoaded', () => {
            if (window.innerWidth <= 715) {
                this.initSwiper();
            } else {
                this.disableSwiper();
            }
        })
    }

    initSwiper() {
        const swiper = document.querySelector(this.swiperContainer);
        if (swiper && (this.swiper === undefined || this.swiper.destroyed)) {
            const slidesWrapper = document.querySelector(this.swiperSlidesContainer);
            if (!slidesWrapper.classList.contains('swiper-wrapper')) {
                slidesWrapper.classList.add('swiper-wrapper');
            }
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: "auto",
                spaceBetween: 16,
                centeredSlides: true,
                loop: false,
                preloadImages: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            });
        }
    }

    disableSwiper() {
        if (this.swiper != undefined && !this.swiper.destroyed) {
            const slidesWrapper = document.querySelector(this.swiperSlidesContainer);
            if (slidesWrapper.classList.contains('swiper-wrapper')) {
                slidesWrapper.classList.remove('swiper-wrapper');
            }
            this.swiper.destroy();
        }
    }
}
